// export const mainBaseUrl = 'http://localhost:8080/';
// export const apiBaseUrl = 'http://localhost:3000/';
// export const imgBaseUrl = 'http://localhost:3000/uploads/';

export const mainBaseUrl = "https://app.meetsplanner.com/";
export const apiBaseUrl = 'https://meeting-apis.vercel.app/';
export const imgBaseUrl = 'https://meeting-apis.vercel.app/uploads/';


